import { clients } from 'lib/https';
import type { ConfigurationSettings } from 'models/configuration-settings';

export interface DashboardFile {
  fileId: string;
  fileName: string;
  extension: string;
  conversationId: string;
  conversationTitle?: string;
  messageId?: string;
  createdDate: string;
  size: number;
  /** Conversation creator; older backends omit it. */
  ownerId?: string;
  /** Title and number of this (latest) version; older dashboards omit them. */
  title?: string | null;
  version?: number | null;
}

export interface DashboardsResponse {
  data: DashboardFile[];
  totalCount: number;
  page: number;
  pageSize: number;
}

/** Epoch milliseconds, same as the media-library file filters. */
export interface DashboardDateRange {
  startTs?: number;
  endTs?: number;
}

export const DASHBOARDS_PAGE_SIZE = 10;

export const fetchDashboards = (
  config: ConfigurationSettings,
  page: number,
  search: string,
  range: DashboardDateRange = {}
) => {
  const body: Record<string, unknown> = {
    dashboardsOnly: true,
    page,
    pageSize: DASHBOARDS_PAGE_SIZE,
  };
  if (search) body.search = search;
  if (range.startTs) body.startTs = range.startTs;
  if (range.endTs) body.endTs = range.endTs;

  return clients.post<DashboardsResponse>(
    `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.mediaLibrary}`,
    config.blocksKey,
    JSON.stringify(body)
  );
};
